import { Component, Input } from '@angular/core';
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';

@Component({
    selector: 'tag-cloud-widget-ng2',
    template: `<div style="text-align: center; border-top: none; background-color: white; height: 130px;">
                <div style="width: 350px; margin: auto;">
                    <angular-tag-cloud
                        [data]="data"
                        [width]="options.width"
                        [height]="options.height"
                        [overflow]="options.overflow">
                    </angular-tag-cloud>
                </div>
             </div>`
})

export class TagCloudWidgetComponentNg2 {
    options: CloudOptions = {
        width: 350,
        height: 150,
        overflow: false
    }
    @Input() text1: string;

    @Input() data: Array<CloudData>;

    constructor() {}
}


/** WEBPACK FOOTER **
 ** ./src/components/explore/widgets/tagCloudWidgetNg2.ts
 **/